import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const opsLevel = defineConnector({
  identifier: "opsLevel",
  name: "OpsLevel",
  tagLine: "Service catalog and developer portal",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://api.opslevel.com"),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "Bearer {secrets.apiToken}" },
    },
  ]),
  steps: [
    {
      title: "Set up OpsLevel",
      items: [
        {
          kind: "markdown",
          content:
            "Open **API tokens** in OpsLevel and create a token with read access. Copy it when shown and enter it below. See [API setup](https://docs.opslevel.com/docs/graphql).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          defaultValue: "https://api.opslevel.com",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Use the OpsLevel API host. The connection test sends a read-only GraphQL query to /graphql.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Create an API token in OpsLevel from the API page in the side menu. Use a token with read-only permissions for this read-only connector.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://api.opslevel.com").trim().replace(/\/+$/, "") +
        "/graphql",
      ...{
        method: "POST",
        expectedBodyContains: ['"account"', '"name"'],
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: '{"query":"{ account { name } }"}',
      },
    }),
  },
});
